import React from 'react';
import { Layout } from "antd";
import ComingSoon from '../layouts/comingSoon.layout';


const ProfilePage : React.FC = () => {
    return (
        <Layout>
            <ComingSoon title="Perfil bloqueado por infrigir a lei LGBT"/>
        </Layout>
      );
};

export default ProfilePage ;
